import React from 'react';
import './Home.css'
import image from '../assets/home.svg'
import image1 from '../assets/modalImg1.svg'
import Particles from "react-tsparticles";
import Login from './Login'
import store from '../redux'


class Home extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            name : '',
            isLogin: false,
            isMount: false
        }
    }

    componentDidMount() {
        store.subscribe(() => 
            this.setState({
                name : store.getState().state.name,
                isLogin : store.getState().state !== ''
            })
        )
        this.setState({
            isMount: true
        })
    }

    componentWillUnmount() {
        this.setState({
            isMount: false
        })
    }

    render() {
        return(
            <div className="home" style={this.props.expanded ? {paddingLeft:20+"%"} : {paddingLeft:5+"%"} }>
                <h1>Selamat Datang{this.state.name !== undefined && this.state.name !== '' ? ", "+this.state.name : ''}</h1>
                <p>Waktu terus berjalan, belajarlah dari masa lalu, bersiaplah tuk masa depan, berikan yg terbaik untuk hari ini.</p>
                <img src={image} className="img-fluid" alt="" />
                {this.state.isLogin && this.state.isMount? <button className="btn btn-info btn-lg btn-block" onClick={() => {store.dispatch({type:'ROUTE_CALENDAR'})}} >Mulai</button> : <Login /> }
                <button className="btn btn-outline-info btn-lg btn-block" data-toggle="modal" data-target="#exampleModal">Tentang</button>
                <div className="modal fade " ref={modal1 => this.modal1 = modal1} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title mx-auto" id="exampleModalLabel">Resolusi & Apresiasi</h5>
                        </div>
                        <div className="modal-body">
                            <img src={image1} className="img-fluid" alt="" />
                            <p className="modalText">
                                &emsp;<span className="font-weight-bold">Resolusi & Apresiasi</span> merupakan sebuah website yang bisa <span className="font-weight-bold">menyimpan</span>, <span className="font-weight-bold">menunjang</span>, dan <span className="font-weight-bold">menampilkan</span> resolusi
                                dalam bentuk grafik sehingga mudah untuk <span className="font-weight-bold">memantau</span> semua <span className="font-weight-bold">resolusi</span> yang kita buat, selain itu setiap
                                kita berhasil mencapai resolusi, kita akan mendapatkan <span className="font-weight-bold">apresiasi</span> berupa kata-kata mutiara.
                            </p>
                            <p className="text-center">Dibuat dengan &nbsp;<i className="fa fa-heart" style={{color:"red"}}></i>&nbsp; oleh <a href="https://faisalhakim.com/"> Awosky </a></p>
                        </div>
                        <div className="modal-footer ">
                            <button type="button" className="btn btn-secondary mx-auto" data-dismiss="modal">Tutup</button>
                        </div>
                    </div>
                    </div>
                </div>
                {this.state.isMount ? 
                <Particles
                    id="tsparticles"
                    canvasClassName="animateBackground"
                    options={{
                        background: {
                            color: {
                            value: "#ffffff",
                            },
                        },
                        fpsLimit: 60,
                        interactivity: {
                            detectsOn: "canvas",
                            events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                            },
                            modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40,
                            },
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4,
                            },
                            },
                        },
                        particles: {
                            color: {
                                value: "#64b2cd",
                            },
                            links: {
                                color: "#3c70a4",
                                distance: 150,
                                enable: true,
                                opacity: 0,
                                width: 1,
                            },
                            collisions: {
                                enable: true,
                            },
                            move: {
                                direction: "none",
                                enable: true,
                                outMode: "bounce",
                                random: false,
                                speed: 6,
                                straight: false,
                            },
                            number: {
                                density: {
                                    enable: true,
                                    value_area: 800,
                                },
                                value: 100,
                            },
                            opacity: {
                            value: 0.5,
                            },
                            shape: {
                            type: "circle",
                            },
                            size: {
                            random: true,
                            value: 5,
                            },
                        },
                        detectRetina: false,
                    }}
                />
                :''}
            </div>
        )
    }
}

export default Home;